import { ReactNode, forwardRef, useState } from "react"
import Icon from "lib/components/Icons"
import Input from "lib/components/Input"

export interface InputPasswordProps {
  label?: string
  placeholder: string
  onChange(object): void
  value?: string | number
  name: string
  disabled?: boolean
  maxLength?: number
  success?: boolean
  /** Shown under the box while `success` is set. */
  successMessage?: string
  error?: boolean
  message?: string
  /** Neutral hint under the box; replaced by `message` while `error` is set. */
  helperText?: ReactNode
}

/** Wraps `Input` with a trailing eye icon that toggles the value between hidden and shown. */
const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  (
    {
      label,
      placeholder,
      onChange,
      value,
      name,
      disabled,
      maxLength,
      success,
      successMessage,
      error,
      message,
      helperText,
    }: InputPasswordProps,
    inputPasswordRef,
  ) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
      <Input
        ref={inputPasswordRef}
        type={showPassword ? "text" : "password"}
        label={label}
        placeholder={placeholder}
        onChange={(event) => onChange(event)}
        value={value}
        name={name}
        disabled={disabled}
        maxLength={maxLength}
        success={success}
        error={error}
        message={message}
        helperText={success && successMessage ? successMessage : helperText}
        autoComplete="off"
        rightIcon={
          <button
            type="button"
            disabled={disabled}
            aria-label={showPassword ? "Hide password" : "Show password"}
            onClick={() => setShowPassword(!showPassword)}
            className="flex items-center">
            <Icon iconName={showPassword ? "eye-slash" : "eye"} width={20} height={20} />
          </button>
        }
      />
    )
  },
)

InputPassword.displayName = "InputPassword"

export default InputPassword
